import React from 'react';
import '../CSS/style.css' 
import Header from '../Componentes/header'
import Footer from '../Componentes/footer'
import { Button, Form, FormGroup, Input, FormFeedback, InputGroup, Label, Col, Row } from 'reactstrap'
import history from '../historial'
import { toast } from 'react-toastify'
import Fetch from '../Auxiliares/fetch'
import validaciones from '../Auxiliares/validaciones'


export default class Registrarse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nombre: '',
            ap_paterno: '',
            ap_materno: '',
            rfc: '',
            rol: 'auxiliar',
            errors: {} 
        }
    }

    componentDidMount() {
        if(localStorage.getItem('token')) history.push('/inicio')
    }
    

    registrate = (e) => {
        e.preventDefault();
        const { nombre, ap_paterno, ap_materno, rfc, rol } = this.state

        if (validaciones.sinErrores(this.state.errors)) {
            Fetch('/api/register',{
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ nombre, ap_paterno, ap_materno, rfc, rol })
                }).then(Response => {
                        history.push('/')
                }).catch(err => { 
                    switch (err.status) {
                        case 600:
                            toast.error('Error inesperado')
                            break;

                        case 601:
                            toast.error('Este usuario ya existe')
                            break;
                        
                        case 604:
                            toast.error('Este usuario no pudo ser registrado, verifique los campos')
                            break;

                        case 801:
                            toast.error('Nombre invalido');
                            break;
                        
                        case 804:
                            toast.error('Apellido paterno invalido');
                            break;

                        case 805:
                            toast.error('Apellido materno invalido');
                            break;

                        case 806:
                            toast.error('RFC invalido');
                            break;

                        case 807:
                            toast.error('Rol invalido');
                            break;

                        default:
                            break;
                    }
                 })
                }
            }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                case 'nombre':
                    if (validaciones.validar_nombre(this.state.nombre)) {
                        value = validaciones.validar_nombre(this.state.nombre)
                        this.setState(prevState => ({ errors: { ...prevState.errors, nombre: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).nombre) });
                    }
                    break;

                case 'ap_paterno':
                    if (validaciones.validar_ap_paterno(this.state.ap_paterno)) {
                        value = validaciones.validar_ap_paterno(this.state.ap_paterno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_paterno: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ap_paterno) });
                    }
                    break;

                case 'ap_materno':
                    if (validaciones.validar_ap_materno(this.state.ap_materno)) {
                        value = validaciones.validar_ap_materno(this.state.ap_materno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_materno: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ap_materno) });
                    }
                    break;

                case 'rfc':
                    if (validaciones.validar_rfc(this.state.rfc)) {
                        value = validaciones.validar_rfc(this.state.rfc)
                        this.setState(prevState => ({ errors: { ...prevState.errors, rfc: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).rfc) });
                    }
                    break;

                case 'rol':
                    if (validaciones.validar_rol(this.state.rol)) {
                        value = validaciones.validar_rol(this.state.rol)
                        this.setState(prevState => ({ errors: { ...prevState.errors, rol: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).rol) });
                    }
                    break;
                
                default:
                    break;
            }
        })
    }

    render() {
        return (
            <html>
                <Header />
                <div className="container">
                        <div class="form">
                            <Form className="register-form" method="post" encType="multipart/form-data" onSubmit={this.registrate}>
                                <FormGroup style={{textAlign:'left'}}>
                                <Label> Nombre </Label>
                                <Input type="text" onChange={this.setValue.bind(this,"nombre")} 
                                invalid={this.state.errors.nombre} placeholder="[Introduzca su nombre]" 
                                name="nombre" value={this.state.nombre}
                                />
                                <FormFeedback>{this.state.errors.nombre}</FormFeedback>
                                </FormGroup>

                                <FormGroup style={{textAlign:'left'}}>
                                <Label> Apellido Paterno </Label>
                                <Input type="text" onChange={this.setValue.bind(this,"ap_paterno")} 
                                invalid={this.state.errors.ap_paterno} placeholder="[Introduzca su Apellido Paterno]" 
                                name="ap_paterno" value={this.state.ap_paterno}
                                />
                                <FormFeedback>{this.state.errors.ap_paterno}</FormFeedback>
                                </FormGroup>

                                <FormGroup style={{textAlign:'left'}}>
                                <Label> Apellido Materno </Label>
                                <Input type="text" onChange={this.setValue.bind(this,"ap_materno")} 
                                invalid={this.state.errors.ap_materno} placeholder="[Introduzca su Apellido Materno]" 
                                name="ap_materno" value={this.state.ap_materno}
                                />
                                <FormFeedback>{this.state.errors.ap_materno}</FormFeedback>
                                </FormGroup>

                                
                                <FormGroup style={{textAlign:'left'}}>
                                <Label> RFC </Label>
                                <Input type="text" onChange={this.setValue.bind(this,"rfc")} 
                                invalid={this.state.errors.rfc} placeholder="[Introduzca su RFC]" 
                                name="rfc" value={this.state.rfc}
                                />
                                <FormFeedback>{this.state.errors.rfc}</FormFeedback>
                                </FormGroup>

                                <FormGroup style={{textAlign:'left'}}>
                                <Row>
                                <Col xs="12" md="4"> Rol de Usuario</Col>
                                <Col xs="12" md="8">
                                <Input type="select" onChange={this.setValue.bind(this,"rol")} 
                                value={this.state.rol}
                                style={{border:'none', backgroundColor:'whitesmoke', width:'100%'}}
                                >
                                    <option>Auxiliar</option>
                                    <option>Personal</option>
                                    <option>Administrador</option>
                                </Input>
                                </Col>
                                </Row>
                                <br/>
                                <br/>
                                </FormGroup>

                                <Button className="bg-info" style={{width:"90%"}}>Registrarse</Button>
                                <p class="message">¿Ya estas registrado? <a href="/" className="text-info">Iniciar Sesion</a></p>
                            </Form>
                    </div>
                </div>
                <Footer />
            </html>
        )
    }
}
